import { createSlice } from "@reduxjs/toolkit";

interface appState {
  user: null | any;
  loading: boolean;
  refetch: boolean;
  authError: null | string;
  pendingVerificationEmail: null | string;
}

const initialState: appState = {
  user: null,
  loading: true, // Start with loading true to check auth on app startup
  refetch: false,
  authError: null,
  pendingVerificationEmail: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    toggleRefetch: (state) => {
      state.refetch = !state.refetch;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAuthError: (state, action) => {
      state.authError = action.payload;
    },
    setPendingVerificationEmail: (state, action) => {
      state.pendingVerificationEmail = action.payload;
    },
    clearPendingVerificationEmail: (state) => {
      state.pendingVerificationEmail = null;
    },
  },
});
const authActions = authSlice.actions;
const authReducer = authSlice.reducer;

export { authActions, authReducer };
